<template>
	<div>
		<v-row>
			<v-col cols="12" md="3">
			</v-col>
			<v-col cols="12" md="6">
				<date-navigator v-model="dateRange">
					<div class="text-center">
						<v-btn color="primary" small dark class="mx-1" @click="loadData">
							دریافت اطلاعات
						</v-btn>
					</div>
				</date-navigator>
			</v-col>
			<v-col cols="12" md="3" class="d-flex align-center justify-end">
				<export-excel :items="items" :headers="headers" :fileName="excelFileName">
				</export-excel>
			</v-col>
		</v-row>
		<v-row>
			<v-col cols="12">
				<v-data-table dense :headers="headers" :loading="loading" :items="filteredItems" :footer-props="{ 'items-per-page-options': [5, 15, 50, 100] }" :items-per-page="50" class="elevation-1">
					<template v-slot:item.member="{ item }">
						<div class="pointer" @click="viewMember(item.member)">{{ item.member ? item.member.fullName : '' }}</div>
						<div class="grey--text">{{ item.member ? item.member.nationalCode : '' }}</div>
					</template>
					<template v-slot:item.date_Persian="{ item }">
						<div>{{ item.date_Persian.date }}</div>
						<div>{{ item.date_Persian.time }}</div>
					</template>
					<template v-slot:item.result="{ item }">
						<div @click="showInquiryResult(item.result)" style="max-width:250px;overflow:hidden;cursor:pointer;text-overflow: ellipsis;white-space: nowrap;">
							{{ item.result }}
						</div>
					</template>
					<template v-slot:item.price="{ item }">
						{{ item.price.toString().toPriceFormat() }}
					</template>
				</v-data-table>
			</v-col>
		</v-row>

		<v-dialog v-model="inquiryResultDialog" max-width="450px">
			<v-card>
				<v-card-title>
					<div><span class="headline">نتیجه استعلام</span></div>
					<v-spacer />
					<v-btn @click="inquiryResultDialog = false" icon>
						<v-icon>mdi-close</v-icon>
					</v-btn>
				</v-card-title>
				<v-card-text>
					<v-container>
						<p style="white-space: pre-wrap;">{{ inquiryResult }}</p>
					</v-container>
				</v-card-text>
			</v-card>
		</v-dialog>

		<v-dialog v-model="dialogMember" scrollable persistent max-width="1000px">
			<modify-member :data="selectedMember" v-if="dialogMember" @callbck="dialogMember = false" @close="dialogMember = false" />
		</v-dialog>

	</div>
</template>

<script>
import api from '@/util/app-api'
import toast from '@/util/toast'
import VuePersianDatetimePicker from 'vue-persian-datetime-picker'
import { call, get } from 'vuex-pathify'

export default {
	name: 'SmsList',
	props: {
		autoLoad: { type: Boolean, default: true },
		area: { type: String, default: '' },
	},
	components: {
		ConfirmDlg: () => import('@/components/Confirm'),
		'date-picker': VuePersianDatetimePicker,
		'modify-member': () => import('@/views/admin/ModifyMember'),
		'date-navigator': () => import('@/components/DateNavigator'),
	},
	data() {
		return {
			errorMessages: '',
			statusFilter: [],
			dialogMember: false,
			selectedMember: {},
			loading: false,
			rowLoading: '',
			headers: [
				{
					text: 'مشتری',
					align: 'right',
					sortable: true,
					value: 'member',
				}, {
					text: 'نوع استعلام',
					align: 'right',
					sortable: true,
					value: 'appInquiryTypeText',
				}, {
					text: 'زمان استعلام',
					align: 'center',
					sortable: true,
					value: 'date_Persian',
				}, {
					text: 'پنل استعلام',
					align: 'right',
					sortable: true,
					value: 'inquiryPanelText',
				}, {
					text: 'نتیجه',
					align: 'right',
					sortable: true,
					value: 'result',
					width: 200
				}
			],
			items: [],
			inquiryResultDialog: false,
			inquiryResult: '',
			dateRange: { start: new Date().toJSON(), end: '' },
		}
	},
	computed: {
		...get('siteConfig', [
			'isCloud'
		]),
		excelFileName() {
			let name = 'گزارش استعلام ها'
			if (this.dateRange.start)
				name += ' از ' + this.dateRange.start.toString().split('T')[0]
			if (this.dateRange.end)
				name += ' تا ' + this.dateRange.end.toString().split('T')[0]
			name += '.xls'
			return name
		},
		filteredItems() {
			return this.items
			if (!(this.statusFilter || []).length)
				return this.items
			let clonedItems = []
			clonedItems.push(...this.items)
			clonedItems = clonedItems.filter(x => this.statusFilter.indexOf(x.statusText) > -1)
			return clonedItems
		}
	},
	created() {
		if (this.area === 'superadmin') {
			this.headers.splice(0, 0, {
				text: 'مشتری',
				align: 'right',
				sortable: true,
				value: 'customer.name',
			})
		}
		if (this.isCloud) {
			this.headers.push({
				text: 'هزینه',
				align: 'center',
				sortable: true,
				value: 'price',
			})
		}
	},
	mounted() {
		if (this.autoLoad)
			this.loadData()
	},
	methods: {
		loadData() {
			this.loading = true
			api.get(`${this.area}/appInquiry/list/?start=` + this.dateRange.start + '&end=' + this.dateRange.end, null)
				.then(
					response => {
						this.items = response
					})
				.catch(err => {
					toast.error(err.message)
				})
				.finally(x => {
					this.loading = false
				})
		},
		showInquiryResult(text) {
			this.inquiryResult = text
			this.inquiryResultDialog = true
		},
		viewMember(member) {
			if (!member || !member.id)
				return
			this.selectedMember = member
			this.dialogMember = true
		},
	},
}
</script>
<style scoped></style>